import React, { useMemo } from 'react';
import { CalendarBlank, Clock } from '@phosphor-icons/react';

function formatUtility(utility) {
  const date = new Date(utility.at);
  if (Number.isNaN(date.getTime())) {
    return { time: '--:--', date: 'Horário indisponível', timeZone: utility.timeZone };
  }

  try {
    const commonOptions = { timeZone: utility.timeZone };
    return {
      time: new Intl.DateTimeFormat('pt-BR', {
        ...commonOptions,
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      }).format(date),
      date: new Intl.DateTimeFormat('pt-BR', {
        ...commonOptions,
        weekday: 'long',
        day: '2-digit',
        month: 'long',
      }).format(date),
      timeZone: utility.timeZone.replace(/_/g, ' '),
    };
  } catch {
    return { time: '--:--', date: 'Horário indisponível', timeZone: utility.timeZone };
  }
}

/** A focused answer for a clock request, intentionally smaller than a response card. */
export default function CompactUtilityCard({ utility }) {
  const formatted = useMemo(() => formatUtility(utility), [utility]);
  const label = utility.label || 'Hora atual';

  return (
    <article className="athena-compact-utility-card athena-compact-utility-clock" aria-label={`${label}: ${formatted.time}`}>
      <header>
        <span className="athena-compact-utility-icon"><Clock size={18} weight="regular" aria-hidden="true" /></span>
        <span>{label}</span>
      </header>
      <time className="athena-compact-utility-time" dateTime={utility.at}>{formatted.time}</time>
      <footer>
        <span><CalendarBlank size={14} weight="regular" aria-hidden="true" />{formatted.date}</span>
        <small>{formatted.timeZone}</small>
      </footer>
    </article>
  );
}
